import styled from 'styled-components';
import ContainedButton  from '../../atoms/ContainedButton';
import {ReadOnlyTag} from '../../atoms/Tag';
import Divider from '../../atoms/Divider';
import ScoreChart from '../../molecules/ScoreChart';
import TextButton,{TextButtonBase} from '../../atoms/TextButton';
import QuizContent from '../../organisms/QuizContent';
import IconButton from '../../atoms/IconButton';
import DropDown from '../../molecules/DropDown';

import {
	ArrowLeftIcon,
	ThumbsUpIcon,
	StarIcon,
	PlayIcon,
	ChevronDownIcon,
	ChevronUpIcon,
	TimerIcon,
	OkSignIcon
} from '../../atoms/Icons';
import {
	SurfaceColor, 
	HoverColor,
	DividerColor, 
	Grey500, 
	Grey600,
	ShadowColor, 
	DisableColor,
	OnAccentColor,
	Yellow,
	OnSurface,
	DefaultPrimaryColor,
	DarkPrimaryColor
} from '../../Colors';

const defaultStyle = {
	Wrapper : styled.div`
        background-color : ${SurfaceColor};
        white-space: pre-wrap;
        height : 100%;
        display : flex;
        flex-direction : column;
    `,
	Header : styled.div`
        position:relative;
        display : flex;
        padding : 1rem 0 1rem 1rem;
        border-bottom : dotted 1px ${DividerColor};
        color : ${Grey600};
        background-color : ${HoverColor};
    `,
	HeaderIconWrapper : styled.div`
    `,
	DropDown : styled(DropDown).attrs({
		pullRight : true
	})`
        position : absolute;
        right : 5px;
        top : 5px;
        font-size : 2rem;
    `,
	UserName : styled(TextButtonBase)`
        color : ${DefaultPrimaryColor};
        padding : 0;
    `,
	HeaderTextWrapper : styled.div`
        overflow-wrap : break-word;
    `,
	Title : styled.div`
        font-size : 2rem;
    `,
	QuizInfo : styled.div`
        padding-right : 1rem;
        padding-bottom : 0.5rem;
        background-color : ${SurfaceColor};
        color : ${Grey500};
        text-align : right;
    `,
	DiscriptionWrapper : styled.div`
        padding : 1rem;
        color : ${OnSurface};
        display : flex;
        &>:last-child{
            margin-left : auto;
            margin-top : auto;
        }
    `,
	Discription : styled.div`
        padding : 1rem;
        text-align : left;
    `,
	ScoreChart,
	LastUpdate : styled.div`
        padding-right : 1rem;
        padding-bottom : 0.5rem;
        color : ${Grey500};
        text-align : right;
    `,
	ChevronDownIcon : styled(ChevronDownIcon)`
        margin-right : 1rem;
    `,
	ChevronUpIcon : styled(ChevronUpIcon)`
        margin-right : 1rem;
    `,
	ShowMoreButton : styled(TextButton)`
    `,
	IconButton : styled(IconButton)`
        color : ${Grey600};
        font-size : 2rem;
        margin-right : 2rem;
    `,
	TagsWrapper : styled.div`
        text-align : right;
        position : absolute;
        bottom : 5px;
        right : 5px;
    `,
	ReadOnlyTag : styled(ReadOnlyTag)`
        margin-right : 1rem;
        color : ${DefaultPrimaryColor};
        &:hover{
            color : ${DarkPrimaryColor};
        }
    `,
	Body : styled.div`
    `,
	ActionsWrapper : styled.div`
        margin-top : auto;
        padding : 0 1rem 1rem 1rem;
        display : flex;
        justify-content: space-between;
        border-top : 1px dotted ${DividerColor};
        padding-top : 1rem;
    `,
	ButtonsWrapper : styled.div`
    `,
	ActionIconsWrapper : styled.div`
        font-size : 3rem;
        color : ${Grey500};
        &:disabled{
            color : ${DisableColor};
        }
    `,
	IconText : styled.span`
        font-size : 1rem;
        margin-right : 1rem;
        color : ${Grey500};
        &:disabled{
            color : ${DisableColor};
        }
    `,
	PlayButton : styled(ContainedButton)`
        margin-left : 1rem;
        font-size : 1.5rem;
    `,
	Divider : styled(Divider)`
        border-top: 1px dotted ${DividerColor};
    `,
	QuizContent : styled(QuizContent)`
        color : ${OnSurface};
    `,
	h4 : styled.h4`
        color : ${Grey600};
        margin : 0;
        padding : 0.5rem 0 0.5rem 0.5rem;
        background-color : ${HoverColor};
        border : dotted 1px ${DividerColor};
    `,
	h5 : styled.h5`
        color : ${Grey600};
        margin : 0;
        padding : 0.5rem 0 0.5rem 0.5rem;
        background-color : ${HoverColor};
        border : dotted 1px ${DividerColor};
    `,
	ActionIconButton : styled(IconButton)`
        color : ${Grey500};
    `,
	ArrowLeftIcon,
	ThumbsUpIcon,
	StarIcon : styled(StarIcon)`
        ${({fav})=>fav&& `
        color : ${Yellow};`}
    `,
	PlayIcon : styled(PlayIcon)`
        color : ${OnAccentColor};
        margin-right : 0.5rem;
    `,
	UserIcon : styled.img.attrs({
		width : '50px',
		height : '50px'
	})`
        border-radius : 1rem;
        cursor : pointer;
    `,
	TimerIcon : styled(TimerIcon)`
        margin-right : 1rem;
    `,
	OkSignIcon : styled(OkSignIcon)`
        margin-right : 1rem;
    `,
};

const mobileStyle = {
	Wrapper : styled.div`
        height : 100%;
        background-color : ${SurfaceColor};
        border : 1px solid ${DividerColor};
        border-radius : 3px;
        white-space: pre-wrap;
        &:hover{
            box-shadow: 0 3px 6px ${ShadowColor};
        }
    `,
	Header : styled.div`
        position:relative;
        display : flex;
        padding : 1rem 0 1rem 1rem;
        color : ${Grey600};
        background-color : ${HoverColor};
        border : dotted 1px ${DividerColor};
    `,
	Body : styled.div`
        min-height : 60vh;
    `,
	IconButton : styled(IconButton)`
        color : ${Grey600};
        font-size : 2rem;
        margin-right : 2rem;
    `,
	UserName : styled(TextButtonBase)`
        color : ${Grey600};
        padding : 0;
    `,
	ReadOnlyTag : styled(ReadOnlyTag)`
        margin-right : 1rem;
        color : ${DefaultPrimaryColor};
        &:hover{
            color : ${DarkPrimaryColor};
        }
    `,
};
export default defaultStyle;
export {mobileStyle};
